<div class="empty-panel"></div>

<div class="side-panel">

    <div class="row">
        <div class="col title">
            <app-go-back></app-go-back> {{ 'CampEnrollment.PageTitle' | translate }}</div>
    </div>

    <form [formGroup]="searchForm" novalidate class="voffset-20">
        <div class="form-group form-horizontal">


            <div class="form-group form-horizontal voffset-20">
                <label class="panel-label">{{ 'CampEnrollment.club' | translate }}</label>
                <bcu-drop-down-multiselect-cf2 [isDisabled]="isBusy" [options]="clubDropdownItems" [shortenWhenAllSelected]="true" [selectAllOption]="true" (changed)="onClubsChanged($event)">
                </bcu-drop-down-multiselect-cf2>
            </div>

            <hr />

            <div class="form-group form-horizontal voffset-20">
                <label class="panel-label">{{ 'CampEnrollment.category' | translate }}</label>
                <bcu-drop-down-multiselect-cf2 [isDisabled]="isBusy" [options]="categorieDropdownItems" [shortenWhenAllSelected]="true" [selectAllOption]="true" (changed)="onCategoryChanged($event)">
                </bcu-drop-down-multiselect-cf2>
            </div>

            <hr />

            <div class="form-group form-horizontal voffset-20">
                <label class="panel-label">{{ 'CampEnrollment.week' | translate }}</label>
                <bcu-drop-down-multiselect-cf2 [isDisabled]="isBusy" [options]="monthsDropdownItems" [shortenWhenAllSelected]="true" [selectAllOption]="true" (changed)="onWeekChanged($event)">
                </bcu-drop-down-multiselect-cf2>
            </div>

            <hr />

            <div class="form-group form-horizontal voffset-20">
                <label class="panel-label">{{ 'CampEnrollment.age' | translate }}</label>
                <bcu-drop-down-multiselect-cf2 [isDisabled]="isBusy" [options]="ageDropdownItems" [shortenWhenAllSelected]="true" [selectAllOption]="true" (changed)="onAgeChanged($event)">
                </bcu-drop-down-multiselect-cf2>
            </div>



        </div>
    </form>
</div>
